import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=8f33ef16"
import script from "./Organizations.vue?vue&type=script&lang=ts"
export * from "./Organizations.vue?vue&type=script&lang=ts"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=8f33ef16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports